// extracted by mini-css-extract-plugin
module.exports = {"form":"ChangeFlagForm_form__3yxMy","field":"ChangeFlagForm_field__2Kibz"};